import "./style.css"

function Error() {    

    return (
        <div className='page_error'>
            Error
        </div>
    )
}

export default Error;